import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { CommonModule, Location } from '@angular/common';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { environment } from 'environments/environment';
import { SharedComponentModule } from '@shared/components/shared-component.module';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { PwaService } from '@shared/service/app/pwa.service';

@Component({
  selector: 'app-reporte',
  standalone: true,
  imports: [CommonModule, RouterModule, SharedComponentModule, MatIconModule, MatTooltipModule],
  templateUrl: './reporte.component.html'
})
export class ReporteComponent implements OnInit, OnDestroy {
  reporteUrl: string;
  safeUrl: SafeResourceUrl;
  isObjectUrl = false; 
  isActive = false;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private pwaService: PwaService,
    private location: Location,
    private sanitizer: DomSanitizer
  ) {}

  ngOnInit(): void {
    const nav = this.router.getCurrentNavigation();
    const stateFromNav = nav?.extras?.state as { blobUrl?: string, mime?: string, fileName?: string } | undefined;
    const stateFromHistory = (window.history.state || {}) as { blobUrl?: string, mime?: string, fileName?: string };

    const state = stateFromNav?.blobUrl ? stateFromNav : (stateFromHistory?.blobUrl ? stateFromHistory : undefined);

    if (state?.blobUrl) {
      this.reporteUrl = state.blobUrl;
      this.isObjectUrl = this.reporteUrl.startsWith('blob:');
      this.safeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.reporteUrl);
      return;
    }

    this.route.paramMap.subscribe(params => {
      const path = params.get('path');
      if (path) {
        if (path.startsWith('http://') || path.startsWith('https://')) {
          this.reporteUrl = path.replace(/^http:\/\//i, 'https://');
        } else {
          this.reporteUrl = `${environment.baseRest}/${path}`;
        }
        this.safeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.reporteUrl);
      } else {
        console.error('No se proporcionó el camino del reporte');
      }
    });
  }

  ngOnDestroy(): void {
    if (this.isObjectUrl && this.reporteUrl?.startsWith('blob:')) {
      URL.revokeObjectURL(this.reporteUrl);
    }
  }

  goBack() {
    this.location.back();
    this.isActive = true;
  }
}